(function(){
  function rsiButton(f){
    return (f && f.querySelector('#rsi_buy_now_button')) || document.querySelector('.ns-hero #rsi_buy_now_button') || document.querySelector('.ns #rsi_buy_now_button');
  }
  function init(root){
    if(root.getAttribute('data-ns-ready')) return; root.setAttribute('data-ns-ready','1');
    var vid=parseInt(root.getAttribute('data-variant'),10);
    var prices={1:root.getAttribute('data-p1'),2:root.getAttribute('data-p2'),3:root.getAttribute('data-p3')};
    var addUrl=root.getAttribute('data-add')||'/cart/add', clearUrl=root.getAttribute('data-clear')||'/cart/clear', cartUrl=root.getAttribute('data-cart')||'/cart';
    var h={'Content-Type':'application/json','Accept':'application/json'};
    var radios=root.querySelectorAll('.ns-bundles input[type=radio]');
    function q(){for(var i=0;i<radios.length;i++){if(radios[i].checked)return parseInt(radios[i].value,10);}return 1;}
    function upd(){var n=q();
      root.querySelectorAll('.ns-qty').forEach(function(i){i.value=n;});
      root.querySelectorAll('[data-price]').forEach(function(e){e.textContent=prices[n];});
      root.querySelectorAll('.ns-bundle').forEach(function(b){b.classList.toggle('is-on',b.querySelector('input').checked);});
    }
    radios.forEach(function(r){r.addEventListener('change',upd);}); upd();

    root.querySelectorAll('.ns-form').forEach(function(f){
      f.addEventListener('submit',function(e){
        e.preventDefault();
        upd();
        var rsi=rsiButton(f);
        if(rsi){ rsi.click(); return; }
        var b=f.querySelector('.ns-cta'); if(b.classList.contains('is-busy')) return; b.classList.add('is-busy');
        fetch(clearUrl+'.js',{method:'POST',headers:h})
          .then(function(){return fetch(addUrl+'.js',{method:'POST',headers:h,body:JSON.stringify({items:[{id:vid,quantity:q()}]})});})
          .then(function(r){if(!r.ok) throw new Error('add'); window.location.href='/checkout';})
          .catch(function(){b.classList.remove('is-busy'); HTMLFormElement.prototype.submit.call(f);});
      });
    });

    root.querySelectorAll('[data-ns-add]').forEach(function(btn){
      btn.addEventListener('click',function(){
        if(btn.classList.contains('is-busy')) return; btn.classList.add('is-busy'); upd();
        fetch(addUrl+'.js',{method:'POST',headers:h,body:JSON.stringify({items:[{id:vid,quantity:q()}]})})
          .then(function(r){if(!r.ok) throw new Error('add'); window.location.href=cartUrl;})
          .catch(function(){btn.classList.remove('is-busy'); window.location.href=cartUrl;});
      });
    });

    var main=root.querySelector('[data-main]'), th=root.querySelectorAll('.ns-thumbs button');
    if(main){
      th.forEach(function(t){t.addEventListener('click',function(){main.scrollTo({left:parseInt(t.getAttribute('data-i'),10)*main.clientWidth,behavior:'smooth'});});});
      main.addEventListener('scroll',function(){var i=Math.round(main.scrollLeft/main.clientWidth);th.forEach(function(t,k){t.classList.toggle('is-on',k===i);});},{passive:true});
    }

    var d=root.querySelector('[data-date]');
    if(d && window.Intl){
      var add=function(n){var x=new Date();while(n>0){x.setDate(x.getDate()+1);var w=x.getDay();if(w!==0&&w!==6)n--;}return x;};
      var fmt=new Intl.DateTimeFormat('it-IT',{weekday:'short',day:'numeric',month:'short'});
      d.textContent=fmt.format(add(2))+' e '+fmt.format(add(5));
    }

    var st=root.querySelector('.ns-sticky'), hf=root.querySelector('.ns-hero .ns-form');
    if(st && hf){
      var ticking=false;
      var check=function(){ticking=false; st.classList.toggle('is-on', hf.getBoundingClientRect().bottom<0);};
      window.addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(check);}},{passive:true});
      window.addEventListener('resize',check); check();
    }
  }
  function all(){document.querySelectorAll('.ns[data-variant]').forEach(init);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',all);}else{all();}
  document.addEventListener('shopify:section:load',all);
})();